import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import BusinessIcon from "@mui/icons-material/Business";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import PeopleIcon from "@mui/icons-material/People";
import { Room } from "../../types/room";

type MeetingRoomProps = {
  room: Room;
  onClick: any;
  border: string;
  actionText: string;
  bypassShowAction?: boolean;
  disabled?: boolean;
};

const MeetingRoom = ({
  room,
  onClick,
  border,
  actionText,
  bypassShowAction = false,
  disabled = false,
}: MeetingRoomProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("tablet"));

  return (
    <Box
      p={2}
      sx={{
        border: border,
        width: "100%",
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              width: 40,
              height: 40,
              backgroundColor: theme.colors.action.hoverShadow,
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MeetingRoomOutlinedIcon
              color={disabled ? "disabled" : "primary"}
            />
          </Box>
          <Stack direction="column" spacing={0} alignItems="flex-start">
            <Typography
              variant="body2"
              sx={{
                color: disabled
                  ? theme.colors.neutral.darkGray
                  : theme.colors.neutral.black,
              }}
            >
              {room?.name}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Stack direction="row" spacing={1} alignItems="center">
                <PeopleIcon
                  sx={{
                    width: "12px",
                    height: "12px",
                    color: disabled
                      ? theme.colors.neutral.gray
                      : theme.colors.neutral.darkGray,
                  }}
                />
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: disabled
                      ? theme.colors.neutral.gray
                      : theme.colors.neutral.darkGray,
                  }}
                >
                  {`${room?.capacity} ${isMobile ? "" : "people"}`}
                </Typography>
              </Stack>
              {room?.floor > 0 && (
                <Stack direction="row" spacing={1} alignItems="center">
                  <BusinessIcon
                    sx={{
                      width: "12px",
                      height: "12px",
                      color: disabled
                        ? theme.colors.neutral.gray
                        : theme.colors.neutral.darkGray,
                    }}
                  />
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: disabled
                        ? theme.colors.neutral.gray
                        : theme.colors.neutral.darkGray,
                    }}
                  >
                    {isMobile ? `${room?.floor}` : `Floor ${room?.floor}`}
                  </Typography>
                </Stack>
              )}
            </Stack>
          </Stack>
        </Stack>
        {!bypassShowAction && (
          <Button
            variant="outlined"
            onClick={onClick}
            disabled={disabled}
            sx={{
              padding: "8px 16px",
              minHeight: "auto",
              lineHeight: 1,
              height: "auto",
              fontSize: "14px",
            }}
          >
            {actionText}
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default MeetingRoom;
